import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class CustomSearchService {

  _url = 'https://www.googleapis.com/customsearch/v1';
  constructor(private _http: HttpClient) { }

  getData(searchString: string | string[]): Observable<any> {
    return this._http.get<any>(this._url, {
      params: {
        q: searchString,
        cx: '003591122780988134931:0p_qvo1-xsa',
        key: 'AIzaSyARHQRjGt2maoB3aNHDjo1nXYs4DEf5VzA',
        searchType: 'image'
      }
    });
  }

}
